import './experience.css'
import experience_sec1 from 'assets/Images/bg/experience_sec1.png'
import experience_sec2 from 'assets/Images/bg/experience_sec2.png'
import experience_sec3 from 'assets/Images/bg/experience_sec3.png'
import experience_sec4 from 'assets/Images/bg/experience_sec4.png'
import { Link } from 'react-router-dom';
import { Fade, Slide } from 'react-reveal';


const Experiences = () => {
  return (
    <div className="experience_page">
      <section className="experience_page_bg_sec bg-pr">
        <div className="experience_hero_sec">
          <Slide cascade bottom>
            <div className="overflow-hidden cs_container">
              <h1>Experience Travelling <br /> - the Cyan way</h1>
              <br />
              <Link to="/" className="cs-btn w-auto cs-outline">Experience Greece</Link>
            </div>
          </Slide>
        </div>
        {/*  */}
        <div className="container">
          <div className="row py-4 mt-md-5 mt-3">
            <div className="col-12 text-white mb-5">
              <Slide bottom>
                <div className="our-story-head center-head-line">
                  <h2 className="py-1">Top Itineraries</h2>
                  <p className="mt-3">1 Country. 25 locations. More than 200 Boats</p>
                </div>
              </Slide>
            </div>
            {/*  */}
            <div className="col-md-6 col-12 px-md-3 px-4 text-white  pt-md-5" >
              <Slide bottom>
                <h2>Mykonos - Tinos - Syros</h2>
                <p className="my-md-5 my-3">
                  One of the most iconic itineraries to discover the hidden gems of Greece.
                  <br /><br />
                  From a whitewashed paradise in Mykonos, to minimal Cycladic architecture in Tinos, all the way to a colorful bliss in Syros.
                  <br /><br />
                  If you want all in one, you are at the right place.  <br /><br />
                </p>
                <Link to="/search/mykonos/flexible" className="cs-btn  w-auto cs-outline">Mykonos Offers</Link>
              </Slide>
            </div>
            <div className="col-md-6 mt-md-0 mt-3 col-12 text-right">
              <Fade>
                <>
                  <img
                    className="img-fluid img_hover"
                    src={experience_sec1}
                    alt="cyan"
                  />
                </>
              </Fade>
            </div>
          </div>
          {/*  */}
          <div className="row flex-md-row-reverse py-md-4 py-2 mt-md-5">
            {/*  */}
            <div className="col-md-6 col-12 px-md-3 px-4 text-white  pt-md-5" >
              <Slide bottom>
                <h2>Corfu - Paxos - Antipaxos</h2>
                <p className="my-md-5 my-3">
                  A unique itinerary especially recommended for families with kids. <br /> <br />
                  The Ionian Sea is known for its cosmopolitan Old Towns, spectacular sandy beaches and beautiful landscapes. <br /> <br />

                  Don’t miss the chance to explore Corfu - Paxos and Antipaxos all in one inclusive voyage. <br /> <br />
                </p>
                <Link to="/search/corfu/flexible" className="cs-btn w-auto cs-outline">Corfu Offers</Link>
              </Slide>
            </div>
            <div className="col-md-6 mt-md-0 mt-3 col-12 text-left">
              <Fade>
                <>
                  <img
                    className="img-fluid img_hover"
                    src={experience_sec2}
                    alt="cyan"
                  />
                </>
              </Fade>

            </div>
          </div>
        </div>
      </section>
      {/*  */}
      <section>
        <div className="container">
          <div className="row py-4 mt-md-5 mt-2">
            <div className="col-12 px-md-3 px-4 mb-md-5 mb-3">
              <Slide bottom>
                <div className="our-story-head center-head-line">
                  <h2 className="py-1">Distinguished Fleet</h2>
                </div>
              </Slide>
            </div>
            {/*  */}
            <div className="col-md-6 col-12 pt-md-5" >
              <Slide bottom>
                <span className="text-sec">Motor Yachts</span>
                <h2>The Elegance of Luxury</h2>
                <p className="my-md-5 mt-3">
                  Choose from a wide variety of distinguished and unique Motor yachts, created and designed by top manufacturers in the world. <br /><br />
                  Create long-lasting memories of the perfect holiday with friends or family and discover different lifestyles and wonders.
                </p>
              </Slide>
            </div>
            <div className="col-md-6 mt-md-0 mt-2 col-12 text-right">
              <Fade>
                <>
                <img
                  className="img_hover img-fluid"
                  src={experience_sec3}
                  alt="cyan"
                  />
                  </>
              </Fade>

            </div>
          </div>
          {/*  */}
          <div className="row flex-md-row-reverse py-4 mt-md-5 mb-5">
            {/*  */}
            <div className="col-md-6 px-md-3 px-4 col-12  pt-md-5" >
              <Slide bottom>
                <span className="text-sec">Sailing Boats</span>
                <h2>The Beauty of simplicity</h2>
                <p className="my-md-5 mt-3">
                  Ever wondered how beautiful and elegant things are when they are not lost in the detail ? Well, it means sifting through tons of soil to find one perfect gem.
                  On the other hand, it doesn't mean a lack of complexity, on the contrary, It’s presented in a simple way that allows us to focus on simple beauty.
                  <br /><br />
                  Get the chance to sail the Aegean sea, with our unique sailing boats and catamarans.
                </p>
              </Slide>
            </div>
            <div className="col-md-6 mt-md-0 mt-2 col-12 text-left">
              <Fade>
              <>
                <img
                  className="img_hover img-fluid"
                  src={experience_sec4}
                  alt="cyan"
                />
              </>
              </Fade>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Experiences

